import axios from "axios";
import ApiService from "@/services/ApiService.js";

export const state = {
  listCarreras: [],
};
export const mutations = {
  GET_CARRERAS({ context }, result_carreras) {
    state.loading = false;
    if (result_carreras) {
      let carreras = [];
      Object.entries(result_carreras).forEach(([key, val]) => carreras.push(val));
      return (state.listCarreras = carreras);
    }
  },
  SAVE_CARRERA({ context }, carrera) {
    state.newCarrera = Object.assign({}, carrera);
  },
};
export const actions = {
  GET_CARRERAS({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.get(data)
        .then(response => {
          // console.log(response.data.data);
          commit("SET_LOADING", false);
          commit("GET_CARRERAS", response.data.data.carreras);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  SAVE_CARRERA({ commit }, data) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.post(data)//funcion de ApiService
        .then(response => {
          commit("SET_LOADING", false);
          commit("SAVE_CARRERA", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  DELETE_CARRERA({ commit }, id) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.delete(id)//funcion de ApiService
        .then(response => {
          //console.log("store",response);
          commit("SET_LOADING", false);
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
};

export const getters = {
  listCarreras: state => state.listCarreras,
};
